import React from 'react';
import styles from './styles.module.css';

export default () => (
    <div className={styles.waveContainer}>
        <div className={styles.wave}/>
        <div className={styles.wave}/>
        <div className={styles.wave}/>
    </div>
)